<template>
  <div ref="container" class="expandable-hover-card loading" @mouseover="expand" @mouseleave="collapse">
      <div ref="cardEl" class="card-content" :class="card.background_color">
        <div class="inner">
            <div class="top-title" v-if="card.top_title" v-html="card.top_title"></div>
            <h2 class="title" v-if="card.title" v-html="card.title"></h2>
            <div ref="hoverCopyEl" class="hover-content" v-if="card.show_hover_content">
                <div class="copy" v-if="hoverContent.copy" v-html="hoverContent.copy"></div>
                <a class="hover-button" v-if="hoverContent.button" :href="hoverContent.button.url" :target="hoverContent.button.target" v-html="hoverContent.button.title"></a>
            </div>
            <div class="hover-invite"><span v-html="hoverContent.hover_invite_text"></span> <i class="fas fa-plus tx-orange"></i></div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
      card: {
          type: Object,
          required: true
      },
    },
    data() {
        return {
            collapsedHeight: 0,
            expandedHeight: 0,
            contentHeight: 0,
        }
    },
    mounted() {
        if (this.card.show_hover_content) {
            this.calculateHeight();
        }
    },
    computed: {
        hoverContent : function() {
            return this.card.hover_content;
        }
    },
    methods: {
        calculateHeight: function() {
             this.expandedHeight = this.$refs.cardEl.offsetHeight;
             this.contentHeight = this.$refs.hoverCopyEl.offsetHeight;
             this.$refs.container.classList.remove('loading');
             this.collapsedHeight = this.$refs.cardEl.offsetHeight;
             this.collapse();
        },
        expand: function() {
            this.$refs.cardEl.style.height = this.expandedHeight + "px";
            this.$refs.hoverCopyEl.style.height = this.contentHeight + "px";
        },
        collapse: function() {
            this.$refs.cardEl.style.height = this.collapsedHeight + "px";
            this.$refs.hoverCopyEl.style.height = "0px";
        }
    }
}
</script>

<style>
    .expandable-hover-card.loading {
        position: absolute;
        visibility: hidden;
    }
</style>